<script>
import LowPrePaymentConfirmModal from "@/views/orders/components/LowPrePaymentConfirmModal.vue";

export default {
  name: "order-generate-invoice-button",
  components: {
    LowPrePaymentConfirmModal,
  },
  emits: ['update'],
  props: {
    entity: Object,
    statusIds: {
      type: Array,
      default: () => ["3bf61851-347c-4d0d-a62e-d488dce9c0da"],
    },
    minimumPrePaymentAmount: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      isConfirmOpen: false
    };
  },
  computed: {
    paidAmount() {
      return Number(this.entity?.paymentAmount || 0);
    },
    hasMinimumPrePaymentMismatch() {
      if (this.minimumPrePaymentAmount === null || this.minimumPrePaymentAmount === undefined) {
        return false;
      }

      return this.paidAmount < Number(this.minimumPrePaymentAmount || 0);
    },
  },
  methods: {
    handleClick() {
      if (this.hasMinimumPrePaymentMismatch) {
        this.isConfirmOpen = true;
        return;
      }

      this.generateInvoice();
    },
    closeConfirmation() {
      if (this.loading) {
        return;
      }

      this.isConfirmOpen = false;
    },
    async generateInvoice() {
      try {
        this.loading = true;
        const response = await this.$store.dispatch("postAPI",
          {
            controller: "order",
            method: "generateInvoice",
            body: {
              id: this.entity.id
            }
          });

        this.$emit("update", response.data.data);
        this.$toast.success("ТТН успішно згенеровано");
        this.isConfirmOpen = false;
      }
      catch (error) {
        this.$toast.warning(error.response.data.message);
      }
      finally {
        this.loading = false;
      }

    },
  }
};
</script>

<template>
  <button
    v-if="entity.deliveryServiceId === '1bf61851-347c-4d0d-a62e-d488dce9c0da' && statusIds.includes(entity.statusId) && !entity.ttn && entity.city && entity.address && entity.deliveryServiceId && entity.recipient && entity.recipientPhone"
    type="button"
    class="btn btn-sm btn-outline-success"
    :disabled="loading"
    v-on:click="handleClick"
  >Генерувати ТТН
  </button>

  <low-pre-payment-confirm-modal
    :is-open="isConfirmOpen"
    :loading="loading"
    :minimum-pre-payment-amount="Number(minimumPrePaymentAmount || 0)"
    :paid-amount="paidAmount"
    confirm-label="Все одно генерувати"
    loading-label="Генерується..."
    @close="closeConfirmation"
    @confirm="generateInvoice"
  />
</template>
